import { createContext, useEffect, useState } from "react";
import { isNewTemplate } from "../lib/data";

export const TemplateVersionContext = createContext({});

export const TemplateVersionProvider = ({ templateVersion, children }) => {
    const [isNewTemplateUsed, setNewTemplate] = useState();

    useEffect(() => {
        if (!isNewTemplateUsed && templateVersion) {
            setNewTemplate(isNewTemplate(templateVersion));
        }
    }, [isNewTemplateUsed, templateVersion]);

    return <TemplateVersionContext.Provider value={{ isNewTemplateUsed, setNewTemplate }}>{children}</TemplateVersionContext.Provider>;
};
